import type { CancelPolicySubmitPayload } from "@tm/insurance/api";
import type { CancelPolicyStepState } from "../types";

export const buildCancelPolicySubmitPayload = ({
  bookingId,
  stepStateById,
}: {
  bookingId: string;
  stepStateById: Record<string, CancelPolicyStepState>;
}): CancelPolicySubmitPayload => {
  const mergedStepPayload = Object.values(stepStateById).reduce<
    Record<string, unknown>
  >((acc, stepState) => {
    if (!stepState?.value) return acc;
    return { ...acc, ...stepState.value };
  }, {});

  return {
    bookingId,
    ...(mergedStepPayload as Partial<CancelPolicySubmitPayload>),
  };
};
